module.exports = __webpack_public_path__ + "img/logo.99bfc061.png";